import { useState, useEffect, Fragment } from 'react'
import CardForm from './CardForm';
import {CheckoutProvider} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { apiRequest } from '../../utils/api';

function CheckoutForm({ amount, currency, clientSecret, onSuccess, onError }) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState('idle'); // idle, processing, succeeded, failed
    const stripe = loadStripe(process.env.REACT_APP_STRIPE_API_KEY, {
        betas: ['custom_checkout_beta_6'],
    });

    const fetchClientSecret = () => {
        return new Promise(async (resolve, reject) => {
            try {
                setIsLoading(true);
                setError('');
    
                // Note: In a real implementation, you would use:
                const response = await apiRequest('POST', '/api/index/stripeCreate', {
                    amount: Math.round(parseFloat(amount) * 100), // amount in cents
                });
                if (!response.success) {
                    throw new Error('Failed to create payment intent');
                }
                setIsLoading(false);
                resolve(response.data.secret);
    
            } catch (error) {
                console.error('Failed to create payment intent:', error);
                setError('無法創建付款請求，請稍後再試');
                setIsLoading(false);
                reject(error)
            }
        })
    };
    
    try {
        const handlePaymentMethodCreated = async (paymentMethodData) => {
            // try {
            //     setPaymentMethod(paymentMethodData);
            //     setPaymentStatus('processing');
            //     setIsLoading(true);

            //     if (paymentMethodData.type == 'error') {
            //         setPaymentStatus('failed');
            //         setError(paymentMethodData.error.message);
            //         if (onError) onError(paymentMethodData.error.message);
            //     } else {
            //         setPaymentStatus('succeeded');
            //         if (onSuccess) onSuccess(paymentMethodData);
            //     }
                
            // } catch (err) {
            //     console.error('Payment confirmation error:', err);
            //     setPaymentStatus('failed');
            //     setError('付款處理失敗。請再試一次或聯繫支援。');
            //     if (onError) onError(err);
            //     setIsLoading(false);
            // }
        };
        
        const formatCurrency = (value, currencyCode) => {
            return new Intl.NumberFormat('zh-HK', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2
            }).format(value);
        };
        
        if (paymentStatus === 'succeeded') {
            return (
                <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-md text-center" data-name="payment-success">
                    <div className="mb-4 text-green-500">
                        <i className="fas fa-check-circle text-5xl"></i>
                    </div>
                    <h2 className="text-2xl font-semibold mb-2">付款成功！</h2>
                    <p className="text-gray-600 mb-4">
                        感謝您的付款，金額為 {formatCurrency(amount, currency)}。
                    </p>
                    <p className="text-sm text-gray-500">
                        收據已發送至您的電子郵件地址。
                    </p>
                </div>
            );
        }
        
        return (
            <div className="max-w-md mx-auto" data-name="checkout-form">
                {isLoading && (
                    <div className="flex justify-center items-center h-64" data-name="loading">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
                    </div>)}
                <div className="bg-white p-6 rounded-lg shadow-md mb-4">
                    <CheckoutProvider
                        stripe={stripe}
                        options={{fetchClientSecret}}
                    >
                        <CardForm 
                            onSubmit={handlePaymentMethodCreated}
                            isLoading={isLoading}
                            error={error}
                        />
                    </CheckoutProvider>
                    
                </div>
                
                <div className="text-center text-sm text-gray-500">
                    <p>
                        完成此購買，即表示您同意我們的{' '}
                        <a href="/terms" className="text-blue-600 hover:underline">服務條款</a>
                    </p>
                </div>
            </div>
        );
    } catch (error) {
        console.error('CheckoutForm component error:', error);
        reportError(error);
        return (
            <div className="bg-red-100 p-4 rounded-md">
                <p>載入結帳表單時出錯。請刷新頁面並重試。</p>
            </div>
        );
    }
}

export default CheckoutForm;